import { render, staticRenderFns } from "./InfoHeading.vue?vue&type=template&id=b320906a&scoped=true&"
import script from "./InfoHeading.vue?vue&type=script&lang=js&"
export * from "./InfoHeading.vue?vue&type=script&lang=js&"
import style0 from "./InfoHeading.vue?vue&type=style&index=0&id=b320906a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b320906a",
  null
  
)

export default component.exports